import React from "react"
import styled from "styled-components"
import breakpoints from "@constants/breakpoints"
import { h3Styles, h4Styles } from "@constants/typography"
import HighlightCard from "@components/HighlightCard"

const Container = styled.div`
  padding-top: 68px;

  @media ${breakpoints.tablet} {
    padding: 118px 0 0;
  }

  @media ${breakpoints.laptop} {
    padding: 162px 0 170px;
  }
`

const Header = styled.div`
  ${h4Styles}
  width: 100%;
  padding: 0 20px;
  margin-bottom: 40px;

  @media ${breakpoints.tablet} {
    ${h3Styles}
    margin-bottom: 62px;
    padding: 0 calc(1 / 12 * 100vw);
  }

  @media ${breakpoints.laptop} {
    margin-bottom: 54px;
    padding: 0 calc(1 / 12 * 100vw);
  }
`

const CardWrapper = styled.div`
  @media ${breakpoints.tablet} {
    margin-bottom: 106px;
  }

  @media ${breakpoints.laptop} {
    margin-bottom: 66px;
  }
`

const ExploreBlock = ({ cards }) => {
  return cards && cards.length > 0 ? (
    <Container>
      <Header>Explore the Series</Header>
      {cards.map((card: any, idx: number) => (
        <CardWrapper key={idx}>
          <HighlightCard
            icon={card.icon?.file?.url}
            title={card.title}
            titleColor={card.titleColor}
            largeTitle={card.largeTitle}
            description={card.description?.description}
            descriptionColor={card.descriptionColor}
            footer={card.footer}
            footerColor={card.footerColor}
            justification={card.justification}
            fiftyPercentMedia={card.fiftyPercentMedia}
            image={card.image?.file?.url}
            mobileImage={card.mobileImage?.file?.url}
            imageGif={card.imageGif?.file?.url}
            mobileImageGif={card.mobileImageGif?.file?.url}
            muxVideo={card.muxVideo}
            muxMobileVideo={card.muxMobileVideo}
            wistiaVideoId={card.wistiaVideoId}
            wistiaEmbedCode={card.wistiaEmbedCode}
            videoUrl={card.videoUrl}
            mobileVideoUrl={card.mobileVideoUrl}
            videoThumbnail={card.videoThumbnail?.file?.url}
            autoplayVideo={card.autoplayVideo}
            callToActionButtonText={card.callToActionButtonText}
            callToActionButtonLink={card.callToActionButtonLink}
          />
        </CardWrapper>
      ))}
    </Container>
  ) : null
}

export default ExploreBlock
